<template>
  <div class="footer-container">
    <div class="footer-link">
      <p>
        <a target="_blank" class="first-link" href="https://www.sneea.cn/index.htm">
          <span class="normal-txt">陕西省教育考试院</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.sneac.com/" >
          <span class="normal-txt">陕西省招生考试信息网</span>
        </a>
        <a target="_blank" class="other-link" href="https://gaokao.chsi.com.cn/" >
          <span class="normal-txt">阳光高考网</span>
        </a>
        <a target="_blank" class="other-link" href="https://gaokao.chsi.com.cn/gkzt/gagx2024" >
          <span class="normal-txt">港澳院校招生</span>
        </a>
        <a target="_blank" class="other-link" href="https://yz.chsi.com.cn/" >
          <span class="normal-txt">中国研究生招生信息网</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.chsi.com.cn/" >
          <span class="normal-txt">学信网</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.gfbzb.gov.cn/" >
          <span class="normal-txt">全国征兵网</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.ncss.cn/" >
          <span class="normal-txt">国家大学生就业服务平台</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.cingta.com/opendata/detail/191?name=教育部第四轮学科评估数据" >
          <span class="normal-txt">第四轮学科评估</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.shanghairanking.cn/" >
          <span class="normal-txt">软科排名</span>
        </a>
        <a target="_blank" class="other-link" href="https://eduranking.cn/" >
          <span class="normal-txt">易度排名</span>
        </a>
        <a target="_blank" class="other-link" href="https://www.wurank.net/index.html" >
          <span class="normal-txt">武书连排名</span>
        </a>
        <a target="_blank" class="other-link" href="http://www.chinaxy.com/" >
          <span class="normal-txt">校友会排名</span>
        </a>
      </p>
    </div>
    <div class="footer-box">
      <div style="padding-left: 10px">
        <p class="name">
          西安门道教育科技有限公司
        </p>
        <p class="normal-txt mt-10">
          公司地址：陕西省西安市雁塔区科创路168号西电科技园c座313
        </p>
        <p class="normal-txt">
          联系电话：029-89197055
        </p>
        <p class="normal-txt mt-10">
          <span @click="goXb()">陕ICP备19005241号-2</span>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002002070">
            <span class="normal-txt">陕公网安备 61019002002070号</span>
          </a>
        </p>
      </div>
      <div class="img-code">
        <img src="~@/assets/images/gzhcode.jpg" alt="公众号二维码">
        <img class="ml-20" src="~@/assets/images/tcode.jpg" alt="杨老师二维码">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mFooter",
  methods: {
    goXb() {
      window.open(this.url)
    }
  }
}
</script>

<style scoped lang="stylus">
.footer-container {
  width: 100%;
  background: #434040;
  .mt-10 {
    margin-top 10px
  }
  .ml-20 {
    margin-left 20px
  }
  .footer-link {
    width: 1440px;
    margin: 0 auto;
    padding: 10px 0;
    color: #fff;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #808080;
    .first-link {
      color: #fff;padding-left: 5px;
    }
    .other-link {
      color: #fff;padding-left: 18px;
    }
  }
  .footer-box {
    width: 1440px;
    margin: 0 auto;
    padding: 20px 0;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name {
      font-size: 16px;
      font-weight: PingFangMedium600;
    }

    .normal-txt {
      font-size: 14px;

      a {
        display: inline-block;
        text-decoration: none;
        height: 20px;
        margin-left 30px
        line-height: 20px;
        color: #fff
      }
    }

    .img-code {
      display: block;
      padding: 0 20px;
      height: 100px;

      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}

</style>
